import { render } from "./Facility.vue?vue&type=template&id=5a100b07"
import script from "./Facility.vue?vue&type=script&setup=true&lang=js"
export * from "./Facility.vue?vue&type=script&setup=true&lang=js"

import "./Facility.vue?vue&type=style&index=0&id=5a100b07&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/Facility.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a100b07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a100b07', __exports__)) {
    console.log('reload')
    api.reload('5a100b07', __exports__)
  }
  
  module.hot.accept("./Facility.vue?vue&type=template&id=5a100b07", () => {
    console.log('re-render')
    api.rerender('5a100b07', render)
  })

}


export default __exports__